export default "__VITE_ASSET__6d41b388__"